import React from 'react';
import InmatesTable from './InmatesTable';
import { useParams } from 'react-router-dom';

const List: React.FC = () => {
  const params = useParams<{ facilitiesToDisplay?: string }>();
  const facilitiesToDisplay = params.facilitiesToDisplay ? params.facilitiesToDisplay.split(',').map(Number) : undefined;
  const initialFilters =
    facilitiesToDisplay != null && facilitiesToDisplay.length > 0 ? { facilityIds: facilitiesToDisplay } : undefined;

  return (
    <div className="jarviswidget jarviswidget-color-blueDark">
      <div className="content">
        <h1 className="page-title txt-color-blueDark">
          <i className="fas fa-sm fa-fw fa-users" /> Inmates
        </h1>
        <InmatesTable initialFilters={initialFilters} />
      </div>
    </div>
  );
};

export default List;
